import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export type PricingVariant = "purple" | "orange" | "green";

type PricingFeatureListProps = {
  features: readonly string[];
  variant: PricingVariant;
};

const CHECK_STYLES: Record<PricingVariant, string> = {
  purple: "border-violet-400 text-violet-700",
  orange: "border-orange-400 text-orange-600",
  green: "border-green-400 text-[#08A62F]",
};

export function PricingFeatureList({ features, variant }: PricingFeatureListProps) {
  return (
    <ul className="space-y-3 text-left">
      {features.map((feature) => (
        <li key={feature} className="flex items-start gap-3 text-[15px] font-medium leading-6 text-slate-800">
          <span
            className={cn(
              "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border bg-white",
              CHECK_STYLES[variant],
            )}
            aria-hidden
          >
            <Check className="h-3.5 w-3.5" strokeWidth={3} />
          </span>
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  );
}
